<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">业绩统计<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item" @change="shopChange">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>员工</label>
              <el-select v-model="staffAdminId" placeholder="Select" class="select-item">
                <el-option v-for="item in staffAdminIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>
<!--            <div class="content-input-item">-->
<!--              <label>员工</label>-->
<!--              <el-input v-model="searchValue" placeholder="请输入员工" >-->
<!--                <template #prefix>-->
<!--                  <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>-->
<!--                </template>-->
<!--              </el-input>-->
<!--            </div>-->

          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)">查询</ElButtons>
            </div>
<!--            <div class="content-input-btn">-->
<!--              <ElButtons icon="RefreshLeft" @click="refreshParam">重置</ElButtons>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
<!--        <div class="content-button">-->
<!--          <div>-->
<!--&lt;!&ndash;            <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)"/>&ndash;&gt;-->
<!--          </div>-->
<!--          <div style="display: flex; align-items: center;">-->
<!--            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--          </div>-->

<!--        </div>-->
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              @selection-change="selsChange"
              @header-click="selsAll"
              size="default"
              border
          >
<!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
            <el-table-column property="statDate" label="日期" v-if="checkColList.indexOf('日期') > -1"></el-table-column>
            <el-table-column property="week" label="星期" v-if="checkColList.indexOf('星期') > -1"/>
            <el-table-column property="shopName" label="门店" v-if="checkColList.indexOf('门店') > -1"></el-table-column>
            <el-table-column property="adminName" label="员工" v-if="checkColList.indexOf('员工') > -1"></el-table-column>
            <el-table-column property="" label="洗护只数" v-if="checkColList.indexOf('洗护只数') > -1">
              <template #default="scope">
                <span>{{scope.row.washingNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="复购奖励只数" v-if="checkColList.indexOf('复购奖励只数') > -1">
              <template #default="scope">
                <span>{{scope.row.washingRepurchaseNum}}</span>
              </template>
            </el-table-column>
<!--            <el-table-column property="" label="洗澡项目" v-if="checkColList.indexOf('洗澡项目') > -1" class-name="cursor">-->
<!--              <template #default="scope">-->
<!--                <span style="color: #409eff">{{scope.row.washingMoney}}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column property="" label="增值服务" v-if="checkColList.indexOf('增值服务') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.incrementMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="物品销售" v-if="checkColList.indexOf('物品销售') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.goodSalesMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="猫咪接送（次）" v-if="checkColList.indexOf('猫咪接送（次）') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.pickUpNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="活体销售" v-if="checkColList.indexOf('活体销售') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.liveSalesMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="全身剃毛" v-if="checkColList.indexOf('全身剃毛') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.barberingMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="特殊服务" v-if="checkColList.indexOf('特殊服务') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.specialMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="定制套餐" v-if="checkColList.indexOf('定制套餐') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.customMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="寄养" v-if="checkColList.indexOf('寄养') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.fosterCareMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="其他" v-if="checkColList.indexOf('其他') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.otherMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="洁牙项目" v-if="checkColList.indexOf('洁牙项目') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.teethCleanMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="不计提成项目" v-if="checkColList.indexOf('不计提成项目') > -1" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.noCommissionMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="充值业绩" v-if="checkColList.indexOf('充值业绩') > -1" class-name="cursor">
              <template #default="scope">
                <span  style="color: #409eff">{{scope.row.userPayMoney}}</span>
              </template>
            </el-table-column>
<!--            <el-table-column property="" label="总提成" v-if="checkColList.indexOf('总提成') > -1">-->
<!--              <template #default="scope">-->
<!--                <span>{{scope.row.allMoney}}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="sumDataList"
              style="width: 100%;"
              v-loading="listLoading"
              size="default"
              border
          >
            <el-table-column property="" label="汇总"></el-table-column>
            <el-table-column property="" label=""></el-table-column>
            <el-table-column property="" label=""></el-table-column>
            <el-table-column property="" label=""></el-table-column>
            <el-table-column property="washingNum" label="洗护只数"></el-table-column>
            <el-table-column property="washingRepurchaseNum" label="复购奖励只数"></el-table-column>
<!--            <el-table-column property="washingMoney" label="洗澡项目"></el-table-column>-->
            <el-table-column property="incrementMoney" label="增值服务"></el-table-column>
            <el-table-column property="goodSalesMoney" label="物品销售"></el-table-column>
            <el-table-column property="pickUpNum" label="猫咪接送"></el-table-column>
            <el-table-column property="liveSalesMoney" label="活体销售"></el-table-column>
            <el-table-column property="barberingMoney" label="全身剃毛"></el-table-column>
            <el-table-column property="specialMoney" label="特殊服务"></el-table-column>
            <el-table-column property="customMoney" label="定制套餐"></el-table-column>
            <el-table-column property="fosterCareMoney" label="寄养"></el-table-column>
            <el-table-column property="otherMoney" label="其他"></el-table-column>
            <el-table-column property="teethCleanMoney" label="洁牙项目"></el-table-column>
            <el-table-column property="noCommissionMoney" label="不计提成项目"></el-table-column>
            <el-table-column property="userPayMoney" label="充值业绩"></el-table-column>
<!--            <el-table-column property="allMoney" label="总提成"></el-table-column>-->
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getFormData, imgPostFormData, postFormData} from "@/api/api";
import {getBonusStatPageList, getBonusStatSummary, listShopStaff} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserInfo from "@/components/User/userInfo";
import DatePickerRange from "@/components/DatePickerRange_noL";
import RecordList from "@/views/user/components/RecordList";
import SearchUidOrPhone from "@/components/SearchUidOrPhone";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import { decimal_NUM, add } from "@/assets/shared/util";
import remarkDialog from "@/views/stat/components/ComsumeRemarkDialog";
import consumeNumDialog from "@/views/stat/components/consumeNumDialog";
import ProjectShopDialog from "@/views/stat/components/ProjectShopDialog";
import BonusNumDialog from "@/views/stat/components/BonusNumDialog";
import BonusUserPayDialog from "@/views/stat/components/BonusUserPayDialog";
import unLock from "@/layout/components/unLock";

export default {
  name: "StatBonus",
  components: {BtnGroup, SearchComponents, SearchUidOrPhone, UserInfo, DatePickerRange, RecordList, unLock },
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      staffAdminIdArray: [
        {name: '不限', id: 0}
      ],
      staffAdminId: 0,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
        {label: '未知', value: 0}
      ],
      sex: -1,


      //刷新组
      colList: ['日期', '星期',  '门店', '员工', '洗护只数', '复购奖励只数', '洗澡项目', '增值服务', '物品销售', '猫咪接送（次）', '活体销售','全身剃毛', '特殊服务', '定制套餐', '寄养', '其他', '洁牙项目', '不计提成项目',  '充值业绩', '总提成'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '称呼', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //抵扣时间
      startDeductionTime: '',
      endDeductionTime: '',
      isDeductionChecked: true,

      idArray: [],
      sort: 2,

      upChargeLoading: false,


    }
  },
  methods: {

    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.isDeductionChecked = true;
      this.sex = -1;
      this.shopId = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    shopChange() {
      this.staffAdminId = 0
      this.staffAdminIdArray = [
        {name: '不限', id: 0}
      ]
      if(this.shopId != 0) {
        getFormData(listShopStaff, {id: this.shopId}).then(data => {
          this.staffAdminIdArray = this.staffAdminIdArray.concat(data.data)
        })
      }
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['staffAdminId'] = this.staffAdminId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getBonusStatPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          // this.pageDataList.map(item => {
          //   item.allMoney = add([item.washingMoney, item.incrementMoney, item.goodSalesMoney, item.liveSalesMoney, item.otherMoney, item.userPayMoney])
          // })
          this.getSumPage(param)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    getSumPage(param) {
      getFormData(getBonusStatSummary, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.sumDataList = []
          let result = data['data'];
          // result.allMoney = add([result.washingMoney, result.incrementMoney, result.goodSalesMoney, result.liveSalesMoney, result.otherMoney, result.userPayMoney])
          this.sumDataList.push(result)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
          .catch((response) => {
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },


    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }


      // if(column.label == '备注') {
      //   let remarkForm = Object.assign({}, row);
      //   Dialog.open({
      //     title: '更新备注',
      //     component: remarkDialog,
      //     data: {
      //       remarkForm: remarkForm,
      //       width: '500px'
      //     },
      //     confirm: () => {
      //       this.getPage()
      //     }
      //   })
      // }

      // if(column.label == '消费单量') {
      //   let bonusForm = Object.assign({}, row);
      //   Dialog.open({
      //     title: '消费单量',
      //     component: consumeNumDialog,
      //     data: {
      //       bonusForm: bonusForm,
      //       serviceType: 0,
      //       width: '1200px'
      //     },
      //     confirm: () => {
      //       this.getPage()
      //     }
      //   })
      // }

      // if(column.label == '洗护只数') {
      //   let bonusForm = Object.assign({}, row);
      //   Dialog.open({
      //     title: '洗护只数',
      //     component: consumeNumDialog,
      //     data: {
      //       bonusForm: bonusForm,
      //       serviceType: 1,
      //       width: '1200px'
      //     },
      //     confirm: () => {
      //       this.getPage()
      //     }
      //   })
      // }

      if(column.label == '洗澡项目') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '洗澡项目',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 1,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '增值服务') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '增值服务',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 2,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '物品销售') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '物品销售',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 3,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '猫咪接送（次）') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '猫咪接送（次）',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 6,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '活体销售') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '活体销售',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 4,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '全身剃毛') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '全身剃毛',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 9,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '定制套餐') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '定制套餐',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 7,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '特殊服务') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '特殊服务',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 10,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '寄养') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '寄养',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 8,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '其他') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '其他',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 5,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '洁牙项目') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '其他',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 11,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '不计提成项目') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '其他',
          component: BonusNumDialog,
          data: {
            bonusForm: bonusForm,
            serviceType: 12,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '充值业绩') {
        let bonusForm = Object.assign({}, row);
        Dialog.open({
          title: '充值业绩',
          component: BonusUserPayDialog,
          data: {
            bonusForm: bonusForm,
            width: '1200px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }




    },


    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        title: '',
        component: SearchInfoDialog,
        data: {
          userForm: e,
          width: '700px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
